export const NutritionIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="26"
    fill="none"
    viewBox="0 0 25 26"
    {...props}
  >
    <path
      fill="currentColor"
      fillOpacity="0.8"
      fillRule="evenodd"
      d="M12.594 4.167H12.5C6.701 4.167 2 8.868 2 14.667s4.701 10.5 10.5 10.5S23 20.466 23 14.667c0-5.336-3.98-9.743-9.135-10.412.285-1.017.665-1.967 1.163-2.754L13.972.833c-.621.981-1.064 2.142-1.378 3.334m.533 5.713a24.6 24.6 0 0 1 .446-4.401c4.603.531 8.177 4.442 8.177 9.188a9.25 9.25 0 1 1-9.44-9.248l-.025.134a26 26 0 0 0-.408 4.327 5.25 5.25 0 0 1-3.09-1.5l-.883.883a6.5 6.5 0 0 0 9.192 0l-.884-.884a5.25 5.25 0 0 1-3.085 1.5"
      clipRule="evenodd"
    ></path>
  </svg>
);
